import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { MatxTheme } from "./components";
import SettingsProvider from "./contexts/SettingsContext";
import routes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TableCacheProvider } from "./common/tablecachecontext"; // <- path to your file
// import TicketChatBot from './TicketChatBot'
// import { DropdownProvider } from "./contexts/DropdownContext";

// import { DataPrefetchProvider } from "./DataPrefetch";

// ✅ Import React Query Client
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// ✅ Create a QueryClient instance
const queryClient = new QueryClient();

export default function App() {
  const content = useRoutes(routes);

  return (
    // <DataPrefetchProvider>
    // <DropdownProvider>
      <QueryClientProvider client={queryClient}>  {/* ✅ Wrap your app with QueryClientProvider */}
        <TableCacheProvider>
          <SettingsProvider>
            <MatxTheme>
              <CssBaseline />
              {content}
               {/* <TicketChatBot /> */}
              <ToastContainer />
            </MatxTheme>
          </SettingsProvider>
        </TableCacheProvider>
      </QueryClientProvider>
    // </DropdownProvider>
    //  </DataPrefetchProvider>

  );
}
